import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=6589fbd7&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=6589fbd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589fbd7",
  null
  
)

export default component.exports